import React from "react";
import { Success } from "@bale/ui";
import { strings } from "intl/fa";
import NotifModal from "components/commons/modal/notifModal/NotifModal";

interface Props {
  onClose?: () => void;
  onSubmit?: (confirmed: boolean) => void;
}

export const SuccessfulAuthModal: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <NotifModal
      title={strings.invoicing.submitted_successfully}
      onClose={props.onClose}
      icon={<Success size={50} />}
      primaryButton={{
        label: strings.common.button.understood,
        disable: undefined,
        onClick: () => props.onSubmit?.(true),
      }}
      content={strings.invoicing.registered_sucessfully}
    ></NotifModal>
  );
};
